export { default } from "./diagram3.component";
